/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.feature.onboarding

import androidx.navigation.NavController
import androidx.navigation.NavGraphBuilder
import androidx.navigation.NavOptions
import androidx.navigation.compose.composable
import androidx.navigation.compose.navigation
import kotlinx.serialization.Serializable
import studio.oddpods.cauce.feature.onboarding.painid.PainIdScreen
import studio.oddpods.cauce.feature.onboarding.profile.ProfileSetupScreen
import studio.oddpods.cauce.feature.patients.AddPatientMode
import studio.oddpods.cauce.feature.patients.AddPatientWithSessionScreen

@Serializable
data object OnboardingGraphRoute

@Serializable
data object PainIdRoute

@Serializable
data object ProfileSetupRoute

@Serializable
data object AddFirstPatientRoute

fun NavController.navigateToOnboardingGraph(navOptions: NavOptions? = null) {
    navigate(OnboardingGraphRoute, navOptions)
}

fun NavGraphBuilder.onboardingGraph(
    navController: NavController,
    onCompleted: () -> Unit,
) {
    navigation<OnboardingGraphRoute>(startDestination = OnboardingRouterRoute) {
        composable<OnboardingRouterRoute> {
            OnboardingRouter(
                navController = navController,
                onCompleted = onCompleted,
            )
        }
        composable<PainIdRoute> {
            PainIdScreen(
                onNavigateNext = { navController.navigate(ProfileSetupRoute) },
            )
        }
        composable<ProfileSetupRoute> {
            ProfileSetupScreen(
                onNavigateNext = { navController.navigate(AddFirstPatientRoute) },
            )
        }
        composable<AddFirstPatientRoute> {
            AddPatientWithSessionScreen(
                mode = AddPatientMode.Onboarding,
                onBackClick = {},
                onNavigateToDashboard = onCompleted,
            )
        }
    }
}
